import { Routes } from '@angular/router';

import { AgentGuard } from '@core/guards/agent.guard';
import { LifePlanGuard } from '@core/guards/life-plan.guard';
import { CompositeRouteGuard } from '@core/guards/composite.guard';

import { InsurancesRoutes } from './insurances/insurances.routes';

const AgentRoutes: Routes = [
  {
    path: 'agent/life-plans/:lifePlanId',
    loadChildren: () => import('./life-cicle/life-cicle.module').then(m => m.LifeCicleModule),
    data: { routeGuards: [AgentGuard, LifePlanGuard] },
    canActivate: [CompositeRouteGuard]
  },
  {
    path: 'agent/life-plans/:lifePlanId/user-form',
    loadChildren: () => import('./user-form/user-form.module').then(m => m.UserFormModule),
    data: { routeGuards: [AgentGuard, LifePlanGuard] },
    canActivate: [CompositeRouteGuard]
  },
  {
    path: 'agent/life-plans/:lifePlanId/summary',
    loadChildren: () => import('./summary/summary.module').then(m => m.SummaryModule),
    data: { routeGuards: [AgentGuard, LifePlanGuard] },
    canActivate: [CompositeRouteGuard]
  },
  {
    path: 'agent/life-plans/:lifePlanId/pdf',
    loadChildren: () => import('./pdf/pdf.module').then(m => m.PdfModule),
    data: { routeGuards: [AgentGuard, LifePlanGuard] },
    canActivate: [CompositeRouteGuard]
  }
];

export const LifePlanRoutes: Routes = [...AgentRoutes, ...InsurancesRoutes];
